import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/Apercu-Pro-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/Apercu-Pro-Medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/Apercu-Pro-MediumItalic.woff2%22,%22weight%22:%22500%22,%22style%22:%22italic%22},{%22path%22:%22./fonts/Apercu-Pro-Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/Apercu-Pro-BoldItalic.woff2%22,%22weight%22:%22700%22,%22style%22:%22italic%22}]}],%22variableName%22:%22apercuPro%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'apercuPro', 'apercuPro Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
